module.exports = __webpack_public_path__ + "img/nav-orange.ecb9ec61.svg";